import type { EnrollCourseBodyEnrollmentType } from './enrollCourseBodyEnrollmentType';

export type EnrollCourseBody = {
  /** 강좌 ID */
  courseId: string;
  /** 수강신청 유형 */
  enrollmentType?: EnrollCourseBodyEnrollmentType;
  /** 학생 ID */
  studentId: string;
};
